// extracted by mini-css-extract-plugin
module.exports = {"rating":"vI-z"};